var a = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M8 0a8 8 0 11-.02 16.02A8 8 0 018 0zm0 1.27a6.73 6.73 0 100 13.46A6.73 6.73 0 008 1.27zm-.22 3.05c.33 0 .6.27.6.6v3.1l3.99 1.42a.6.6 0 11-.4 1.14l-4.4-1.56a.6.6 0 01-.4-.57V4.93c0-.34.27-.6.6-.6z", "fill-rule": "nonzero" } }] }, name: "clock", theme: "outlined" };
export {
  a as default
};
